import { point } from "leaflet";
import { createWithEqualityFn } from "zustand/traditional";
import { persist, createJSONStorage } from "zustand/middleware";

//TODO -- will refactor the widget setup store
export const useWidgetSetupStore = createWithEqualityFn((set) => ({
  selectedWidget: "",
  widgetTitle: "",
  widgetIcon: "",
  setupDetails: {},
  widgetDetails: {},

  updateSelectedWidget: (selectedWidget) =>
    set(() => ({ selectedWidget: selectedWidget })),
  updateWidgetIcon: (widgetIcon) => set(() => ({ widgetIcon: widgetIcon })),
  updateWidgetTitle: (widgetTitle) => set(() => ({ widgetTitle: widgetTitle })),
  updateSetupDetails: (setupDetails) =>
    set(() => ({ setupDetails: setupDetails })), //stores to create new widget
  updateWidgetDetails: (widgetDetails) =>
    set(() => ({ widgetDetails: widgetDetails })), //stores info about widget from api
}));

export const useDempStore = createWithEqualityFn(
  persist(
    (set) => ({
      functions: [],
      hidden: [],
      dashboardId: "",
      dashboardType: "",
      companyId: "",
      plantId: "",
      selectedCompanies: [], // NEW: Array to track multiple selected companies
      hierarchicalSelection: false, // NEW: Global setting for hierarchical selection (true = select children, false = parent only)
      timeRange: "?start=-1d&stop=",
      eventDetails: { event_id: "", event_token: "" },
      
   
      updateEventId: (eventDetails) =>
        set(() => ({ eventDetails: eventDetails })),
      updateDashboardType: (dashboardType) =>
        set(() => ({ dashboardType: dashboardType })),
      updateTimeRange: (timeRange) => set(() => ({ timeRange: timeRange })),
      updateDashboardId: (dashboardId) =>
        set(() => ({ dashboardId: dashboardId })),
      updateCompanyId: (companyId) => set(() => ({ companyId: companyId })),
      updatePlantId: (plantId) => set(() => ({ plantId: plantId })),
      updateSelectedCompanies: (selectedCompanies) => 
        set(() => ({ selectedCompanies: selectedCompanies })),
      updateHierarchicalSelection: (hierarchicalSelection) =>
        set(() => ({ hierarchicalSelection: hierarchicalSelection })),
      updateDashboardStates: (dash) =>
        set(() => ({
          dashboardId: dash.dashboardId,
          dashboardType: dash.type,
          companyId: dash.companyId,
          plantId: dash.plantId,
          functions: dash.functions,
          hidden: dash.hidden,
        })),
      
      // NEW: Combined action to update both dashboard states and selected companies
      updateDashboardAndCompanies: (dash) =>
        set(() => ({
          dashboardId: dash.dashboardId,
          dashboardType: dash.type,
          companyId: dash.companyId,
          plantId: dash.plantId,
          functions: dash.functions,
          hidden: dash.hidden,
          selectedCompanies: dash.selectedCompanies,
        })),
    }),
    {
      name: "dashboardStates", // unique name
      storage: createJSONStorage(() => localStorage), // (optional) by default the 'localStorage' is used
    }
  )
);

export const useTHPStore = createWithEqualityFn(
  persist(
    (set) => ({
      mapView: "Map View",
      infoView: "truck",
      setMapView: (mapView) => set(() => ({ mapView: mapView })),
      setInfoView: (infoView) => set(() => ({ infoView: infoView })),
    }),
    {
      name: "THPSTORE101", // unique name
      storage: createJSONStorage(() => sessionStorage), // (optional) by default the 'localStorage' is used
    }
  )
);

export const useWidgetStore = createWithEqualityFn(
  persist(
    (set) => ({
      evRoute: [],
      updateEvRoute: (evRoute) => set(() => ({ evRoute: evRoute })),
    }),
    {
      name: "widgetStates",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export const usePopUpStore = createWithEqualityFn((set) => ({
  popupData: {}, //stores data for the popup
  popupOpen: false, //controls the popup
  openPopup: () => set(() => ({ popupOpen: true })),
  closePopup: () => set(() => ({ popupOpen: false, popupData: {} })),
  updatePopupData: (popupData) =>
    set(() => ({ popupData: popupData, popupOpen: true })),
}));

export const useDeviceManagement = createWithEqualityFn((set) => ({
  isEditDevice: false,
  deviceSetup: {},
  deviceInfo: [],
  huaweiDeviceList: [],
  selectionList: {},
  fieldProperties: [{ address: 1 }],
  updateFieldProperties: (fieldProperties) =>
    set(() => ({ fieldProperties: fieldProperties })),
  updateSelectionList: (selectionList) =>
    set(() => ({ selectionList: selectionList })),
  updateIsEditDevice: (isEditDevice) =>
    set(() => ({ isEditDevice: isEditDevice })),
  updateDeviceInfo: (deviceInfo) => set(() => ({ deviceInfo: deviceInfo })),
  updateDeviceSetup: (deviceSetup) => set(() => ({ deviceSetup: deviceSetup })),
  resetAll: () =>
    set(() => ({
      isEditDevice: false,
      deviceSetup: {},
      deviceInfo: [],
      huaweiDeviceList: [],
      selectionList: {},
      fieldProperties: [{ address: 1 }],
    })),
}));

export const useSatelliteDash = createWithEqualityFn(
  persist(
    (set) => ({
      satelliteData: [],
      updateSatelliteDate: (_data) => set(() => ({ satelliteData: _data })),
    }),
    {
      name: "dateTimeKeys_sat",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

// personalCarEmission: 2.2327,
// km_to_liter: 13.7960,



// set filter branch on dashboard company THP
export const useFilterBranchCompanyTHPStore = createWithEqualityFn((set) => ({
  selectBranch: [], //stores data for the selectBranch

  selectFilterBranch: (id) =>
    set((state) => ({ selectBranch: [...state.selectBranch, id] })),
  selectFilterBranchAll: (group) => set(() => ({ selectBranch: [...group] })),
  deselectFilterBranch: (id) =>
    set((state) => {
      if (id) {
        const deselectFilter = state.selectBranch.filter((item) => item !== id);

        return { selectBranch: [...deselectFilter] };
      }
    }),
  deselectFilterBranchAll: (group) => set(() => ({ selectBranch: [...group] })),
}));

// set filter capacity on dashboard company THP
export const useFilterCapacityCompanyTHPStore = createWithEqualityFn((set) => ({
  filterCapacity: [0, 20, 40, 60, 80, 100], //stores data for the selectBranch

  selectFilterCapacity: (Cap) =>
    set((state) => {
      if (state.filterCapacity.includes(Cap)) {
        const deselectFilter = state.filterCapacity.filter(
          (item) => item !== Cap
        );

        return { filterCapacity: [...deselectFilter] };
      } else {
        return { filterCapacity: [...state.filterCapacity, Cap] };
      }
    }),
  resetFilterCapacity: (defaultValue) =>
    set(() => ({ filterCapacity: [...defaultValue] })),
}));
